import { SCHOOL_ID } from 'src/config-global';
import { handleGeneralErrors } from 'src/utils/error-handler';

export function convertToFormData(data: any) {
  const formData = new FormData();
  // required values
  formData.append('schoolId', SCHOOL_ID.toString());
  formData.append('fullName', data.name);
  formData.append('cardId', data.cardId);
  formData.append('email', data.email);
  formData.append('phone', data.phone);
  formData.append('feeId', data.readerAccountFee);
  formData.append('photo3x4', data.photo);
  formData.append('cardFrontPhoto', data.cardFront);
  formData.append('cardBackPhoto', data.cardBack);
  formData.append('formPhoto', data.registerForm);

  return formData;
}
/* ------- XỬ LÝ LỖI SAU KHI SUBMIT FORM ------ */
const fields: any = {
  fullName: 'Tên bạn đọc',
  email: 'Địa chỉ mail',
  cardId: 'Số CMND/CCCD',
  photo3x4: 'Hình 3x4',
  phone: 'Số điện thoại',
  cardFrontPhoto: 'Mặt trước CMND/CCCD',
  cardBackPhoto: 'Mặt sau CMND/CCCD',
  feeId: 'Thời gian hiệu lực',
  formPhoto: 'Đơn đăng ký',
};
const fieldAlias: any = {
  fullName: 'name',
  email: 'email',
  cardId: 'cardId',
  photo3x4: 'phone',
  phone: 'phone',
  cardFrontPhoto: 'cardFront',
  cardBackPhoto: 'cardBack',
  feeId: 'readerAccountFee',
  formPhoto: 'registerForm',
};
export function handleError(error: any, setError: any) {
  handleGeneralErrors(fields, fieldAlias, error, setError);
}
